import { render, staticRenderFns } from "./IntentQa.vue?vue&type=template&id=e4051e6c&scoped=true"
import script from "./IntentQa.vue?vue&type=script&lang=js"
export * from "./IntentQa.vue?vue&type=script&lang=js"
import style0 from "./IntentQa.vue?vue&type=style&index=0&id=e4051e6c&prod&lang=less"
import style1 from "./IntentQa.vue?vue&type=style&index=1&id=e4051e6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4051e6c",
  null
  
)

export default component.exports